import { render, staticRenderFns } from "./pictogram-table.vue?vue&type=template&id=e365f984&scoped=true"
import script from "./pictogram-table.vue?vue&type=script&lang=js"
export * from "./pictogram-table.vue?vue&type=script&lang=js"
import style0 from "./pictogram-table.vue?vue&type=style&index=0&id=e365f984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e365f984",
  null
  
)

export default component.exports